/**
 * The API's `resourceIds` is a transport-only JSON array of numeric ids, primary first. It
 * is what the server reads to know every resource a booking assigns — the days it must
 * work around, and the BookingResource rows it writes — so a multi-resource booking has to
 * carry it on the save itself, not only in the assignment rows written afterwards.
 */
export function toResourceIdsJson(
  resourceIds: readonly (string | number)[] | undefined,
  primaryResourceId?: string | number | null,
): string | undefined {
  const ids: number[] = [];

  for (const candidate of [primaryResourceId, ...(resourceIds ?? [])]) {
    if (candidate == null) continue;
    const id = typeof candidate === 'number' ? candidate : parseInt(candidate, 10);
    if (!isNaN(id) && id > 0 && !ids.includes(id)) ids.push(id);
  }

  return ids.length > 0 ? JSON.stringify(ids) : undefined;
}
